import { render } from "./NoahMasterManager.vue?vue&type=template&id=622d1e0f&scoped=true"
import script from "./NoahMasterManager.vue?vue&type=script&lang=js"
export * from "./NoahMasterManager.vue?vue&type=script&lang=js"

import "./NoahMasterManager.vue?vue&type=style&index=0&id=622d1e0f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622d1e0f"]])

export default __exports__